import React, { useState } from 'react';
import { createStyles, makeStyles, useTheme } from '@material-ui/core/styles';
import { BoxWrapper } from 'components/Base';
import LinkCard from './LinkCard';
import {
  SpeedRounded as SpeedRoundedIcon,
  DescriptionOutlined as DescriptionOutlinedIcon,
  FileCopyOutlined as FileCopyOutlinedIcon
} from '@material-ui/icons';
import api from 'api';
import { errHelper } from 'utils';
import { CircularProgress } from '@material-ui/core';
import Store from 'store/store';
import { compose } from 'ramda';
const { connect, selectors } = Store;

const useStyles = makeStyles(() =>
  createStyles({
    box: {
      overflow: 'hidden',
      fontSize: '0.9rem'
    },
    flex: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
      height: '100%'
    },
    loader: {
      marginLeft: '0.5rem',
      flex: 'none'
    }
  })
);

const ResourcesTile = ({ riskProfiler }: any) => {
  const theme = useTheme() as any;
  const classes = useStyles();
  const [downloadingAtr, setDownloadingAtr] = useState(false);
  const [downloadingCfl, setDownloadingCfl] = useState(false);
  const [downloadingCombined, setDownloadingCombined] = useState(false);

  const updateState = (value: boolean, type?: string) => {
    if (type === 'cfl') {
      setDownloadingCfl(value);
    } else if (type === 'atr') {
      setDownloadingAtr(value);
    } else {
      setDownloadingCombined(value);
    }
  };

  const downloadQuestionnaire = (type?: string) => {
    let reportName = 'Attitude to Risk and Capacity for Loss Questionnaire.pdf';
    updateState(true, type);

    if (type === 'cfl') {
      reportName = 'Capacity for Loss Questionnaire.pdf';
    } else if (type === 'atr') {
      reportName = 'Attitude to Risk Questionnaire.pdf';
    } else if (type === 'exp') {
      reportName = 'Experience Questionnaire.pdf';
    }

    return api
      .blankQuestionnaire(type)
      .then((response: any) => {
        const url = window.URL.createObjectURL(new Blob([response.data]));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', reportName);
        document.body.appendChild(link);
        link.click();
      })
      .catch((err: any) => {
        errHelper(err);
      })
      .finally(() => {
        updateState(false, type);
      });
  };

  return (
    <BoxWrapper title="Quick downloads" noBorder className={classes.box}>
      <LinkCard
        onClick={() => downloadQuestionnaire('atr')}
        icon={
          <SpeedRoundedIcon
            style={{ fontSize: 48, color: theme.palette.baseColors.secondary }}
          />
        }
      >
        <div className={classes.flex}>
          <div>Attitude to Risk Questionnaire</div>
          {downloadingAtr && (
            <CircularProgress className={classes.loader} size={24} />
          )}
        </div>
      </LinkCard>
      <LinkCard
        onClick={() =>
          downloadQuestionnaire(riskProfiler == 'Evalue' ? 'cfl' : 'exp')
        }
        icon={
          <DescriptionOutlinedIcon
            style={{ fontSize: 48, fill: theme.palette.baseColors.secondary }}
          />
        }
      >
        <div className={classes.flex}>
          {riskProfiler == 'Evalue' ? (
            <div>Capacity for Loss Questionnaire</div>
          ) : (
            <div>Experience Questionnaire</div>
          )}
          {downloadingCfl && (
            <CircularProgress className={classes.loader} size={24} />
          )}
        </div>
      </LinkCard>
      <LinkCard
        onClick={() => downloadQuestionnaire()}
        icon={
          <FileCopyOutlinedIcon
            style={{ fontSize: 48, color: theme.palette.baseColors.secondary }}
          />
        }
      >
        <div className={classes.flex}>
          <div>
            Combined Attitude to Risk and{' '}
            {riskProfiler == 'Evalue'
              ? 'Capacity for Loss Questionnaire'
              : 'Experience Questionnaire'}
          </div>
          {downloadingCombined && (
            <CircularProgress className={classes.loader} size={24} />
          )}
        </div>
      </LinkCard>
    </BoxWrapper>
  );
};

export default compose(
  connect((state: any) => ({
    riskProfiler: selectors.firmSelectors.riskProfiler(state)
  }))
)(ResourcesTile);
